import {Card, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	padding: 16px;
	background-color: ${({theme}) => theme.palette.primary.main};
	cursor: pointer;
	width: fit-content;
	${({theme}) => theme.breakpoints.down('sm')} {
		width: auto;
	}
`;
